import React from 'react';
import PropTypes from 'prop-types';
import styles from './ActionMonitorCard.module.css';

export const ActionMonitorCard = ({ 
  label, 
  value, 
  subText, 
  status, 
  statusType, 
  background 
}) => {
  const getStatusClass = () => {
    switch(statusType) {
      case 'up': return styles.statusUp;
      case 'down': return styles.statusDown;
      case 'stable': return styles.statusStable;
      default: return '';
    }
  };

  return (
    <div className={styles.card} style={{ backgroundImage: `url(${background})` }}>
      <div className={styles.content}>
        <div className={styles.header}>
          <h3 className={styles.label}>{label}</h3>
          {status && (
            <span className={`${styles.status} ${getStatusClass()}`}>
              {status}
            </span>
          )}
        </div>
        <div className={styles.value}>{value}</div>
        {subText && <div className={styles.subText}>{subText}</div>}
      </div>
    </div>
  );
};

ActionMonitorCard.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  subText: PropTypes.string,
  status: PropTypes.string,
  statusType: PropTypes.oneOf(['up', 'down', 'stable']),
  background: PropTypes.any
};